export var sanitizeHeaders = function (headers) {
    var result = {};
    // eslint-disable-next-line no-restricted-syntax
    for (var name_1 in headers) {
        if (Object.hasOwn(headers, name_1)) {
            var value = headers[name_1];
            if (typeof value !== 'undefined') {
                result[name_1] = value;
            }
        }
    }
    return result;
};
